import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// ES 7.x compatibility fix for ReactiveSearch
// Failed prop type: Invalid prop total of type object supplied to ReactiveList, expected 'number'
// Tried to locate where it happens, in searches, requests, responses, still fails. This index.js is the most general place
// to patch anything that sets a "total" property on ReactiveList. The total has changed, in ES 6.9 was a number, and in
// ES 7.X it an object (tuple) We need to access a nested level to update the value.
const originalCreateElement = React.createElement;
React.createElement = function(type, props, ...children) {

    // More robust detection - check for ReactiveList by examining props instead of component names
    // Component names get mangled in production builds, but props structure remains consistent
    if (props &&
        props.componentId &&
        props.pagination !== undefined &&
        props.size !== undefined) {

        // Check if total prop exists and needs conversion
        if (props.total !== undefined) {
            // Apply the ES 7.x compatibility fix
            if (typeof props.total === 'object' && props.total.value !== undefined) {
                props.total = props.total.value;
            }
        }
    }

    // Fallback: Also try the original component name detection for development patching
    if (type && (type.displayName === 'ReactiveList' || type.name === 'ReactiveList' ||
        (type.type && (type.type.displayName === 'ReactiveList' || type.type.name === 'ReactiveList')))) {

        if (props && props.total !== undefined && typeof props.total === 'object' && props.total.value !== undefined) {
            props.total = props.total.value;
        }
    }

    return originalCreateElement.call(this, type, props, ...children);
};

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js